// 硬盘状态列表
import Vue from "vue";

const diskNameMap: { [k: string]: string } = {
    'attached': Vue.$trans(`已挂载`),  //已挂载
    'saving': Vue.$trans(`快照中`),    //快照中
    'restoring': Vue.$trans(`回滚中`), //回滚中

    'system': Vue.$trans(`系统盘`),    //系统盘
    'data': Vue.$trans(`数据盘`),  //数据盘
    'SSD': Vue.$trans(`本地SSD`),    //本地SSD盘
    'SATA': Vue.$trans(`本地SATA`),  //本地SATA盘
    // 老版字段
    'c1': Vue.$trans(`本地SSD`),     //本地SSD盘
    'k1': Vue.$trans(`本地SATA`),    //本地SATA盘
    'c1_en': Vue.$trans(`本地SSD`),     //本地SSD盘
    'root': Vue.$trans(`系统盘`),      //系统盘
    'ephemeral': Vue.$trans(`数据盘`),      //数据盘
    // '':''
};

export const getDiskLocaleNameByCode = (diskTypeCode:string):string|undefined => {
    return diskNameMap[diskTypeCode];
}
